import { useAuth } from "../../context/AuthContext";
import { useRouter } from "@/lib/navigation";
import { useEffect, useState } from "react";
import { auth } from "../../firebase/config";
import { apiUrl } from "@/utils/apiBase";

export default function AdminRoute({ children }) {
  const { user } = useAuth();
  const router = useRouter();
  const [verified, setVerified] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const verify = async () => {
      if (!user || user.role !== "admin") {
        router.push("/");
        return;
      }

      try {
        const firebaseUser = auth.currentUser;
        if (!firebaseUser) {
          router.push("/");
          return;
        }
        const token = await firebaseUser.getIdToken();
        const response = await fetch(apiUrl("/api/auth/verify-admin"), {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ token }),
        });
        if (!response.ok) {
          router.push("/");
          return;
        }
        const data = await response.json();
        if (!cancelled && data.isAdmin) {
          setVerified(true);
        } else if (!cancelled) {
          router.push("/");
        }
      } catch {
        if (!cancelled) router.push("/");
      }
    };

    verify();
    return () => {
      cancelled = true;
    };
  }, [user, router]);

  if (!user || user.role !== "admin" || !verified) {
    return null;
  }

  return <>{children}</>;
}
